<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <div class="kgr-inputGroup">
            <div
                class="kgr-grid kgr-grid--gutters kgr-grid--bigGutters"
                style="align-items: end;"
            >
                <div class="kgr-grid__cell">
                    <kgr-form-row
                        :label="$t('Start')"
                        :error="error"
                        field-name="start"
                    >
                        <kgr-date-picker
                            v-model="start"
                        />
                    </kgr-form-row>
                </div>
                <div class="kgr-grid__cell">
                    <kgr-form-row
                        :label="$t('Ende')"
                        :error="error"
                        field-name="end"
                    >
                        <kgr-date-picker
                            v-model="end"
                        />
                    </kgr-form-row>
                </div>
                <div class="kgr-grid__cell  kgr-text--rightAligned">
                    <button
                        class="kgr-button kgr-button--accent"
                        @click="loadMemberClubFees"
                    >
                        {{ $t('Artikel Anzeigen') }}
                    </button>
                </div>
            </div>
        </div>
        <hr class="kgr-separator--light" />
        <table class="kgr-table kgr-table--block kgr-table--striped printable">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Beitrag') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Kategorie') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Preis') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Anzahl') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('lädt Guthaben auf') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('mit Guthaben gezahlt') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Zahlungsart') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Datum') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-hidden-print"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loading">
                    <td
                        colspan="7"
                        style="text-align: center;"
                    >
                        <kgr-loader />
                    </td>
                </tr>
                <tr v-else-if="salesListFees.length === 0">
                    <td
                        colspan="7"
                        style="text-align: center;"
                    >
                        {{ $t('dataTable.noData') }}
                    </td>
                </tr>
                <template v-else>
                    <tr
                        v-for="fee in salesListFees"
                        :key="fee.id"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            {{ fee.name }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ fee.category }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ getPrice(fee.pricePerTime) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ getQuantityFactor(fee.quantityFactor) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ fee.chargeCredit ? $t('ja') : $t('nein') }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ fee.settleWithCredit ? $t('ja') : $t('nein') }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ fee.paymentMethod }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ formatDateTime(fee.createdAt) }}
                        </td>
                        <td class="kgr-table__cell kgr-table__cell--actions kgr-hidden-print">
                            <button
                                :disabled="!fee.isDeletable"
                                class="kgr-table__action"
                                @click="deleteMemberClubFee(fee.id)"
                            >
                                <kgr-icon
                                    :disabled="!fee.isDeletable"
                                    icon-class="delete"
                                />
                            </button>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </kgr-form-scaffold>
</template>

<script>
import { format, parse, subYears } from '@legacy/js/date/date-fns.js';
import ClubSalesListMemberClubFeeRepository from '../../../js/repository/ClubSalesListMemberClubFeeRepository.js';
import DatePicker from '../../../components/common/form/picker/DatePicker.vue';
import Error from '../../../js/model/Error.js';
import FormRow from '../../../components/common/form/FormRow.vue';
import FormScaffold from '../../../components/common/form/FormScaffold';
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../../components/common/icon/Icon.vue';
import Loading from '../../../components/common/Loading.vue';
import MemberClubFeeRepository from '../../../js/repository/MemberClubFeeRepository.js';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-icon': Icon,
        'kgr-loader': Loading,
        'kgr-date-picker': DatePicker,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            loading: false,
            start: format(subYears(new Date(), 1), 'dd.MM.yyyy'),
            end: format(new Date(), 'dd.MM.yyyy'),
            helper: new Helper(),
            salesListFees: [],
        };
    },
    created() {
        this.loadMemberClubFees();
    },
    methods: {
        loadMemberClubFees() {
            const start = parse(this.start, 'dd.MM.yyyy', new Date());
            const formattedStart = format(start, 'yyyy-MM-dd');
            const end = parse(this.end, 'dd.MM.yyyy', new Date());
            const formattedEnd = format(end, 'yyyy-MM-dd');
            const error = new Error();

            if (formattedEnd < formattedStart) {
                error.add('start', this.$t('Das Enddatum darf nicht vor dem Startdatum liegen.'));
                error.add('end', this.$t('Das Enddatum darf nicht vor dem Startdatum liegen.'));
            }
            this.error = error;

            if (!error.isEmpty()) {
                return;
            }

            this.loading = true;
            const query = `?dateRange=${formattedStart}:${formattedEnd}`;
            ClubSalesListMemberClubFeeRepository.findByMemberIdAndFilters(this.id, query)
                .then((response) => this.salesListFees = response)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => {
                    this.loading = false;
                });
        },
        deleteMemberClubFee(memberClubFeeId) {
            showConfirm(this.$t('confirmInformal'), this.$t('Willst du den Artikel wirklich löschen?'), () => {
                MemberClubFeeRepository.delete(memberClubFeeId)
                    .then(() => this.loadMemberClubFees())
                    .catch(() => this.$notify.error('saveChanges.error'));
            });
        },
        getPrice(pricePerTime) {
            return this.helper.getPrice(pricePerTime);
        },
        getQuantityFactor(quantityFactor) {
            return quantityFactor.numerator / quantityFactor.denominator;
        },
        formatDate(date) {
            return this.helper.formatDate(date);
        },
        formatDateTime(date) {
            return this.helper.formatDateTime(date);
        },
        redirectToOverview() {
            window.location = `/backend/clubs/${this.clubId}/members`;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
